import { createApiSaga } from '../../../sagaGenerator';
import { apiDelete, apiGet, apiPatch } from '../../../../middleware/api';
import {
  DEPOSIT_SEARCH_REQUEST,
  DEPOSIT_SEARCH_WATER_REQUEST,
  DEPOSIT_SEARCH_PUBLICATION_REQUEST,
  DEPOSIT_SEARCH_COUNTRY_REQUEST,
  DEPOSIT_SEARCH_COUNTRY_FAILURE,
  DEPOSIT_SEARCH_COUNTRY_SUCCESS,
  DEPOSIT_SEARCH_FAILURE,
  DEPOSIT_SEARCH_PUBLICATION_FAILURE,
  DEPOSIT_SEARCH_PUBLICATION_SUCCESS,
  DEPOSIT_SEARCH_SUCCESS,
  DEPOSIT_SEARCH_WATER_FAILURE,
  DEPOSIT_SEARCH_WATER_SUCCESS,
  DEPOSIT_SEARCH_GEOAGE_REQUEST,
  DEPOSIT_SEARCH_GEOAGE_FAILURE,
  DEPOSIT_SEARCH_GEOAGE_SUCCESS,
  DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE,
  DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST,
  DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS,
  DEPOSIT_DATA_BULK_EDIT_FAILURE,
  DEPOSIT_DATA_BULK_EDIT_REQUEST,
  DEPOSIT_DATA_BULK_EDIT_SUCCESS,
} from './depositSearchReducer';

const bulkEditDepositsSaga = createApiSaga({
  apiFunction: apiPatch,
  generateApiConfig: action => ({ endpoint: '/tsunamis/deposits', ...action }),
  requestType: DEPOSIT_DATA_BULK_EDIT_REQUEST,
  successType: DEPOSIT_DATA_BULK_EDIT_SUCCESS,
  failureType: DEPOSIT_DATA_BULK_EDIT_FAILURE,
  successMessage: 'Saved',
});

const searchDepositsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/deposits', ...action }),
  requestType: DEPOSIT_SEARCH_REQUEST,
  successType: DEPOSIT_SEARCH_SUCCESS,
  failureType: DEPOSIT_SEARCH_FAILURE,
});

const getPublicationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/publication-types', ...action }),
  requestType: DEPOSIT_SEARCH_PUBLICATION_REQUEST,
  successType: DEPOSIT_SEARCH_PUBLICATION_SUCCESS,
  failureType: DEPOSIT_SEARCH_PUBLICATION_FAILURE,
});

const getBodiesOfWaterSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/bodies-of-water', ...action }),
  requestType: DEPOSIT_SEARCH_WATER_REQUEST,
  successType: DEPOSIT_SEARCH_WATER_SUCCESS,
  failureType: DEPOSIT_SEARCH_WATER_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/countries', ...action }),
  requestType: DEPOSIT_SEARCH_COUNTRY_REQUEST,
  successType: DEPOSIT_SEARCH_COUNTRY_SUCCESS,
  failureType: DEPOSIT_SEARCH_COUNTRY_FAILURE,
});

const getGeoagesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/geologic-ages', ...action }),
  requestType: DEPOSIT_SEARCH_GEOAGE_REQUEST,
  successType: DEPOSIT_SEARCH_GEOAGE_SUCCESS,
  failureType: DEPOSIT_SEARCH_GEOAGE_FAILURE,
});

const deleteDepositSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}`, ...action }),
  requestType: DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST,
  successType: DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS,
  failureType: DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE,
  successMessage: 'Deleted',
});

export const searchDepositsSagas = [
  bulkEditDepositsSaga,
  searchDepositsSaga,
  getPublicationsSaga,
  getBodiesOfWaterSaga,
  getCountriesSaga,
  getGeoagesSaga,
  deleteDepositSaga,
];
